import { render, staticRenderFns } from "./SubjectLabelCategorySelect.vue?vue&type=template&id=3aa66338"
import script from "./SubjectLabelCategorySelect.ts?vue&type=script&lang=ts&external"
export * from "./SubjectLabelCategorySelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SubjectLabelCategorySelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports